import ClientContext from "@limitless/common/utils/client-context/ClientContext";
import { INVALID_COM_EXTENSION, INVALID_CO_UK_EXTENSION, INVALID_GMAIL_DOMAIN, INVALID_HOTMAIL_DOMAIN, INVALID_ICLOUD_DOMAIN, INVALID_OUTLOOK_DOMAIN, INVALID_YAHOO_DOMAIN } from "../../utils/InvalidExtension";
import { isEmailValid, isNameValid, isMobileValid, isCustomerCodeValid } from "../../utils/user-validation/UserValidation";
import { areAnyFieldsPristine } from "../../../expert/utils/FieldValidators";
const domains = [{
  key: "INVALID_GMAIL_DOMAIN",
  value: INVALID_GMAIL_DOMAIN
}, {
  key: "INVALID_HOTMAIL_DOMAIN",
  value: INVALID_HOTMAIL_DOMAIN
}, {
  key: "INVALID_ICLOUD_DOMAIN",
  value: INVALID_ICLOUD_DOMAIN
}, {
  key: "INVALID_OUTLOOK_DOMAIN",
  value: INVALID_OUTLOOK_DOMAIN
}, {
  key: "INVALID_YAHOO_DOMAIN",
  value: INVALID_YAHOO_DOMAIN
}];
export const validateCustomer = (customer, translate, skipQuestion) => {
  let isFormInvalid = true;
  const fieldErrors = {};
  const secondaryFieldErrors = {};
  const regex = /[^\w\s]/;
  const {
    name,
    email,
    question,
    mobileNumber,
    customerLastName,
    tenantSubject,
    verificationCode
  } = customer;
  const fieldsToValidate = {
    name,
    email
  };
  if (!skipQuestion) {
    fieldsToValidate.question = question;
  }
  let isFormIncomplete = false;
  if (ClientContext._userMobileEnabled === "true") {
    fieldsToValidate.mobileNumber = mobileNumber;
    isFormIncomplete = areAnyFieldsPristine(fieldsToValidate);
    if (!mobileNumber.pristine && !isMobileValid(mobileNumber.value)) {
      fieldErrors.mobileNumber = "Please enter a valid mobile number";
    }
  } else {
    isFormIncomplete = areAnyFieldsPristine(fieldsToValidate);
  }
  if (ClientContext._userSubjectsEnabled) {
    if (!isNameValid(tenantSubject.value)) {
      fieldErrors.tenantSubject = "Please select subject";
    }
  }
  if (ClientContext._userLastNameEnabled && customerLastName) {
    if (!customerLastName.pristine && !isNameValid(customerLastName.value)) {
      fieldErrors.customerLastName = "Last Name must be at least 2 characters";
    } else if (!customerLastName.pristine && customerLastName.value.includes("@")) {
      fieldErrors.customerLastName = "Last Name must not contain an email address";
    } else if (!customerLastName.pristine && regex.test(customerLastName.value)) {
      fieldErrors.customerLastName = "Last Name must not contain any special characters";
    } else if (!customerLastName.pristine && customerLastName.value.length > 100) {
      fieldErrors.customerLastName = "Last Name must not contain more than 100 characters";
    }
  }
  if (!name.pristine && !isNameValid(name.value)) {
    fieldErrors.name = "Name must be at least 2 characters";
  } else if (!name.pristine && name.value.includes("@")) {
    fieldErrors.name = "Name must not contain an email address";
  } else if (!name.pristine && regex.test(name.value)) {
    fieldErrors.name = "Name must not contain any special characters";
  }

  // if (ClientContext._newMessageMessageRules === "verify" && verificationCode !== "") {
  //     if (!verificationCode.pristine && isCustomerCodeValid(verificationCode.value)) {
  //         fieldErrors
  //     }

  // }
  if (!email.pristine && !isEmailValid(email.value)) {
    fieldErrors.email = "Please enter a valid email";
  }
  const ErrorMsg = "Please check your email, did you mean ";
  const emailDomainError = domain => {
    switch (domain) {
      case "INVALID_GMAIL_DOMAIN":
        return `${ErrorMsg}gmail?`;
      case "INVALID_HOTMAIL_DOMAIN":
        return `${ErrorMsg}hotmail?`;
      case "INVALID_ICLOUD_DOMAIN":
        return `${ErrorMsg}icloud?`;
      case "INVALID_OUTLOOK_DOMAIN":
        return `${ErrorMsg}outlook?`;
      case "INVALID_YAHOO_DOMAIN":
        return `${ErrorMsg}yahoo?`;
      default:
        return "";
    }
  };
  if (isEmailValid(email.value)) {
    const extension = email.value.match(/.+@(.+)/);
    const groups = extension.pop().split(".");
    const primaryDomain = groups[groups.length - 1];
    const subDomain = `${groups[groups.length - 2]}.${groups[groups.length - 1]}`;
    if (INVALID_COM_EXTENSION.includes(primaryDomain)) {
      secondaryFieldErrors.email = `${ErrorMsg}.com?`;
    } else if (INVALID_CO_UK_EXTENSION.includes(subDomain)) {
      secondaryFieldErrors.email = `${ErrorMsg}.co.uk?`;
    } else {
      var _domains$filter$;
      const domain = email.value.split("@").pop().split(".")[0].toString();
      const domainName = (_domains$filter$ = domains.filter(dom => dom.value.includes(domain))[0]) === null || _domains$filter$ === void 0 ? void 0 : _domains$filter$.key;
      secondaryFieldErrors.email = emailDomainError(domainName);
    }
  }
  if (!skipQuestion && !question.pristine) {
    let trimmedQuestion = question.value;
    if (question.value.trim() === "") {
      trimmedQuestion = question.value.trim();
    }
    if (trimmedQuestion.length < ClientContext._minQuestionCharCount) {
      fieldErrors.question = translate("Your question should be at least {0} characters", ClientContext._minQuestionCharCount);
    }
    if (trimmedQuestion.length > 4000) {
      fieldErrors.question = "Your question must be less than 4,000 characters";
    }
  }
  if (ClientContext._userCaptureSuppress === "email" && name.value !== "" && question.value !== "") {
    Reflect.deleteProperty(fieldErrors, "email");
    isFormIncomplete = false;
  }
  if (ClientContext._userCaptureSuppress === "name" && email.value !== "" && question.value !== "") {
    Reflect.deleteProperty(fieldErrors, "name");
    isFormIncomplete = false;
  }
  if (ClientContext._userCaptureSuppress === "all" && question.value !== "") {
    Reflect.deleteProperty(fieldErrors, "email");
    Reflect.deleteProperty(fieldErrors, "name");
    isFormIncomplete = false;
  }
  isFormInvalid = isFormIncomplete || Object.keys(fieldErrors).length > 0;
  return {
    isFormInvalid,
    secondaryFieldErrors,
    fieldErrors
  };
};